var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scaleContainer",staticClass:"sd-scale-line",attrs:{"id":'scale-label-' + _vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }